<template>
    <div class="account">
        <div class="top_header_fixed">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/flowSourceLists' }">流向</el-breadcrumb-item>
                <el-breadcrumb-item>流向{{ type == 'update' ? '编辑' : '新增' }}</el-breadcrumb-item>
            </el-breadcrumb>
            <div class="title_btn">
                <div>
                    <el-button size="small" plain @click="submit('submitForm')" :loading="btnLoading">保存</el-button>
                    <el-button size="small" plain @click="cancel">取消</el-button>
                </div>
            </div>
        </div>
        <div class="main_list">
            <el-collapse v-model="activeNames">
                <el-collapse-item disabled title="基本信息" name="1">
                    <div>
                        <span style="color: red; font-size: 13px">
                            &nbsp;&nbsp;&nbsp;&nbsp;产品、销量、产品批号、无税总价、含税总价、日期等任意值新增/修改，后台会标记该条流向为人工设置，后续相关基础资料发生变化不会对该条流向产生影响</span
                        >
                    </div>
                    <div>
                        <span style="color: red; font-size: 13px">
                            &nbsp;&nbsp;&nbsp;&nbsp;商业合作方锁定如果打钩，后续流向商业配置匹配流向的时候，不会对该条流向的一级商业和合作方产生影响</span
                        >
                    </div>
                    <div>
                        <span style="color: red; font-size: 13px">
                            &nbsp;&nbsp;&nbsp;&nbsp;代表等字段新增或修改，不会对已有的流向调整产生影响。如需产生影响，请根据实际需求到流向调整页面进行撤销、重分配等操作</span
                        >
                    </div>
                    <div>
                        <span style="color: red; font-size: 13px">
                            &nbsp;&nbsp;&nbsp;&nbsp;推广类型锁定、纯销依据锁定、类型锁定如果打钩，后续合作产品期间路径匹配流向的时候，不会对该条流向的对应字段产生影响</span
                        >
                    </div>
                    <div>
                        <span style="color: red; font-size: 13px">
                            &nbsp;&nbsp;&nbsp;&nbsp;绩效单元锁定、业务单元锁定如果打钩，表示绩效单元和业务单元不要被刷掉（目前暂不自动刷新逻辑）</span
                        >
                    </div>
                    <!-- <div>
                        <span style="color: red; font-size: 13px">
                            &nbsp;&nbsp;&nbsp;&nbsp;流向更新后会自动解绑该条流向与终端授权的绑定关系(因为匹配依赖的数据库可能发生变化)，等下一轮终端授权匹配的时候再次绑定</span
                        >
                    </div> -->
                    <el-form :model="formData" :rules="rules" ref="submitForm" label-position="right" class="details_temp2023">
                        <template v-for="(item, index) in colData">
                            <template v-if="formData.hasOwnProperty(item.prop)">
                                <el-form-item
                                    v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop]['type'] == 'dropdown'"
                                    :key="index"
                                    :label="fieldTypeMap[item.prop]['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <vDropdown
                                        :model_key="item['prop']"
                                        :model_name="'请选择' + fieldTypeMap[item.prop]['title']"
                                        :model_value_default="data[item['prop']]"
                                        :request_uri="fieldTypeMap[item.prop]['request_uri']"
                                        :request_params="fieldTypeMap[item.prop]['request_params'] || {}"
                                        @onDropChange="onDropChange"
                                        :display_name="fieldTypeMap[item.prop]['display_name']"
                                        :select_value="fieldTypeMap[item.prop]['select_value']"
                                        :ref="fieldTypeMap[item.prop]['ref']"
                                    ></vDropdown>

                                    <el-tooltip
                                        v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop].hasOwnProperty('tips')"
                                        class="Tooltip"
                                        effect="dark"
                                        :content="fieldTypeMap[item.prop]['tips']"
                                        placement="top-start"
                                    >
                                        <i class="el-icon-question"></i>
                                    </el-tooltip>
                                </el-form-item>

                                <!-- 日期 -->
                                <el-form-item
                                    v-else-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop]['type'] == 'date'"
                                    :key="index"
                                    :label="fieldTypeMap[item.prop]['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <el-date-picker
                                        v-model="formData[item['prop']]"
                                        :type="fieldTypeMap[item.prop]['date_type']"
                                        :placeholder="'请选择' + fieldTypeMap[item.prop]['title']"
                                        :format="fieldTypeMap[item.prop]['format']"
                                        :value-format="fieldTypeMap[item.prop]['value_format']"
                                        size="mini"
                                        clearable
                                    >
                                    </el-date-picker>

                                    <el-tooltip
                                        v-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop].hasOwnProperty('tips')"
                                        class="Tooltip"
                                        effect="dark"
                                        :content="fieldTypeMap[item.prop]['tips']"
                                        placement="top-start"
                                    >
                                        <i class="el-icon-question"></i>
                                    </el-tooltip>
                                </el-form-item>

                                <el-form-item
                                    v-else-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop]['type'] == 'search_select'"
                                    :key="index"
                                    :label="fieldTypeMap[item.prop]['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <vSearchSelect
                                        :model_key="item.prop"
                                        :model_name="'请输入' + fieldTypeMap[item.prop]['title'] + '搜索'"
                                        :request_uri="fieldTypeMap[item.prop]['request_uri']"
                                        :default_option_key="fieldTypeMap[item.prop]['default_option_key']"
                                        :default_option="formData[fieldTypeMap[item.prop]['default_option_key']]"
                                        @onDropChange="onDropChange"
                                        :ref="fieldTypeMap[item.prop]['ref']"
                                    ></vSearchSelect>
                                </el-form-item>

                                <el-form-item
                                    v-else-if="fieldTypeMap.hasOwnProperty(item.prop) && fieldTypeMap[item.prop]['type'] == 'checkbox'"
                                    :key="index"
                                    :label="fieldTypeMap[item.prop]['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <el-checkbox v-model="formData[item.prop]" style="width: 280px"></el-checkbox>
                                </el-form-item>
                                <el-form-item
                                    v-else
                                    :key="index"
                                    :label="item['title'] + '：'"
                                    :rules="rules[item['prop']] || {}"
                                    :prop="item['prop']"
                                >
                                    <el-input
                                        v-model="formData[item['prop']]"
                                        size="mini"
                                        :placeholder="'请输入' + item.title"
                                        clearable
                                    ></el-input>
                                </el-form-item>
                            </template>
                            <template v-else>
                                <el-form-item v-if="type == 'update'" :key="index" :label="item['title'] + '：'">
                                    <div class="read_only">
                                        {{ data[item['prop']] }}
                                    </div>
                                </el-form-item>
                            </template>
                        </template>
                    </el-form>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
import { in_array, processColDataToEdit, checkNumber } from '@/js/common.js';
import vSearchSelect from '@/components/common/dropdown/search.vue';

export default {
    name: 'commodityFlowEdit',
    components: {
        vSearchSelect
    },
    data() {
        return {
            type: '', // insert or update or copy
            activeNames: ['1'],
            btnLoading: false,
            colData: [], // 字段信息
            formData: {}, // 表单信息
            data: {}, // 详情数据
            fieldTypeMap: {},
            queryParams: {}, // 搜索参数（详情）
            rules: {} // 表单验证信息
        };
    },

    created() {
        this.type = this.$route.query.type;
        this.initQueryParams();
        this.selectedColData(); //筛选列
        this.initFormData();
        this.initFormRule();
        this.initFieldTypeMap();
        if (in_array(this.type, ['update', 'copy'])) {
            this.getData();
        } else {
            this.data.operation_type_code = 2;
        }
    },
    methods: {
        onDropChange(key, value) {
            this.formData[key] = value;
        },
        initFieldTypeMap() {
            this.fieldTypeMap = {
                date: {
                    title: '日期',
                    format: 'yyyy-MM-dd',
                    value_format: 'yyyy-MM-dd',
                    ref: 'date_ref',
                    type: 'date'
                },
                business_rid: {
                    request_uri: 'searchAccounts',
                    title: '一级商业',
                    ref: 'business_rid_ref',
                    default_option_key: 'business_option',
                    type: 'search_select'
                },
                partner_rid: {
                    request_uri: 'dropdownPartners',
                    title: '合作方',
                    ref: 'partner_rid_ref',
                    type: 'dropdown'
                },
                representative_rid: {
                    request_uri: 'dropdownPartners',
                    title: '代表',
                    ref: 'representative_rid_ref',
                    type: 'dropdown'
                },
                product_rid: {
                    request_uri: 'dropdownProducts',
                    title: '产品',
                    ref: 'product_rid_ref',
                    type: 'dropdown',
                    request_params: { is_all: true, type_code: [11, 91] }
                },
                supplier_rid: {
                    request_uri: 'searchAccounts',
                    title: '供方',
                    ref: 'supplier_rid_ref',
                    default_option_key: 'supplier_option',
                    type: 'search_select'
                },
                sup_supplier_rid: {
                    request_uri: 'searchAccounts',
                    title: '上级供方',
                    ref: 'sup_supplier_rid_ref',
                    default_option_key: 'sup_supplier_option',
                    type: 'search_select'
                },
                demander_rid: {
                    request_uri: 'searchAccounts',
                    title: '需方',
                    ref: 'demander_rid_ref',
                    default_option_key: 'demander_option',
                    type: 'search_select'
                },
                sales_basis: {
                    request_uri: 'dropdownSalesBasis',
                    title: '纯销依据',
                    ref: 'sales_basis_ref',
                    type: 'dropdown',
                    select_value: 'value'
                },
                type: {
                    request_uri: 'dropdownFlowType',
                    title: '类型',
                    ref: 'type_ref',
                    type: 'dropdown',
                    select_value: 'value'
                },
                sales_basis_lock: {
                    type: 'checkbox',
                    title: '纯销依据锁定',
                    ref: 'sales_basis_lock_ref'
                },
                type_lock: {
                    type: 'checkbox',
                    title: '类型锁定',
                    ref: 'type_lock_ref'
                },
                config01_lock: {
                    type: 'checkbox',
                    title: '商业合作方锁定',
                    ref: 'config01_lock_ref'
                },
                promotion_type_lock: {
                    type: 'checkbox',
                    title: '推广类型锁定',
                    ref: 'promotion_type_lock_ref'
                },
                performance_unit_lock: {
                    type: 'checkbox',
                    title: '绩效单元锁定',
                    ref: 'performance_unit_lock_ref'
                },
                business_unit_lock: {
                    type: 'checkbox',
                    title: '业务单元锁定',
                    ref: 'business_unit_lock_ref'
                },
                performance_unit_code: {
                    request_uri: 'dropdownPerformanceUnit',
                    title: '绩效单元',
                    ref: 'performance_unit_code_ref',
                    type: 'dropdown',
                    request_params: { is_leaf: true },
                    select_value: 'code',
                    tips: '默认绩效单元可能非叶子节点，无法显示'
                },
                business_unit_code: {
                    request_uri: 'dropdownBusinessUnits',
                    title: '业务单元',
                    ref: 'business_unit_code_ref',
                    type: 'dropdown',
                    select_value: 'code',
                    tips: '非必填，默认从绩效单元截取'
                },
                operation_type_code: {
                    request_uri: 'flowOperationTypes',
                    title: '运营类型',
                    ref: 'operation_type_code_ref',
                    type: 'dropdown',
                    select_value: 'value'
                }
            };
        },
        initFormRule() {
            this.rules = {
                promotion_type: [{ required: true, message: '请输入推广类型', trigger: 'blur' }],
                date: [{ required: true, message: '请选择日期', trigger: 'blur' }],
                product_batch_number: [{ required: true, message: '请输入批号', trigger: 'blur' }],
                quantity: { required: true, validator: checkNumber, trigger: 'blur' },
                total_price_tax_excluded: { required: true, validator: checkNumber, trigger: 'blur' },
                total_price_tax_included: { required: true, validator: checkNumber, trigger: 'blur' },
                business_rid: [{ required: true, message: '请输入一级商业搜索', trigger: 'blur' }],
                partner_rid: [{ required: true, message: '请选择合作方', trigger: 'blur' }],
                representative_rid: [{ required: false, message: '请选择代表', trigger: 'blur' }],
                supplier_rid: [{ required: true, message: '请输入供方搜索', trigger: 'blur' }],
                sup_supplier_rid: [{ required: false, message: '请输入上级供方搜索', trigger: 'blur' }],
                demander_rid: [{ required: true, message: '请输入需方搜索', trigger: 'blur' }],
                product_rid: [{ required: true, message: '请选择产品', trigger: 'blur' }],
                sales_basis: [{ required: true, message: '请选择纯销依据', trigger: 'blur' }],
                type: [{ required: true, message: '请选择类型', trigger: 'blur' }],
                sales_basis_lock: [{ required: false, message: '纯销依据是否锁定', trigger: 'blur' }],
                type_lock: [{ required: false, message: '类型是否锁定', trigger: 'blur' }],
                config01_lock: [{ required: false, message: '商业合作方是否锁定', trigger: 'blur' }],
                promotion_type_lock: [{ required: false, message: '推广类型是否锁定', trigger: 'blur' }],
                performance_unit_lock: [{ required: false, message: '绩效单元是否锁定', trigger: 'blur' }],
                business_unit_lock: [{ required: false, message: '业务单元是否锁定', trigger: 'blur' }],
                performance_unit_code: [{ required: false, message: '请选择绩效单元', trigger: 'blur' }],
                business_unit_code: [{ required: false, message: '业务单元(非必填)', trigger: 'blur' }],
                operation_type_code: [{ required: true, message: '请选择运营类型', trigger: 'blur' }]
            };
        },
        initQueryParams() {
            this.queryParams.rid = this.$route.query.id;
        },
        initFormData() {
            this.formData = {
                rid: this.data.rid || '',
                promotion_type: this.data.promotion_type || '',
                date: this.data.date || '',
                product_batch_number: this.data.product_batch_number || '',
                quantity: this.data.quantity || '',
                total_price_tax_excluded: this.data.total_price_tax_excluded || 0,
                total_price_tax_included: this.data.total_price_tax_included || 0,
                business_rid: this.data.business_rid || '',
                business_option: {
                    rid: this.data.business_rid || '',
                    name: this.data.business && this.data.business.name ? this.data.business.name : ''
                },
                partner_rid: this.data.partner_rid || '',
                representative_rid: this.data.representative_rid || '',
                supplier_rid: this.data.supplier_rid || '',
                supplier_option: {
                    rid: this.data.supplier_rid || '',
                    name: this.data.supplier && this.data.supplier.name ? this.data.supplier.name : ''
                },
                sup_supplier_rid: this.data.sup_supplier_rid || '',
                sup_supplier_option: {
                    rid: this.data.sup_supplier_rid || '',
                    name: this.data.sup_supplier && this.data.sup_supplier.name ? this.data.sup_supplier.name : ''
                },
                demander_rid: this.data.demander_rid || '',
                demander_option: {
                    rid: this.data.demander_rid || '',
                    name: this.data.demander && this.data.demander.name ? this.data.demander.name : ''
                },
                product_rid: this.data.product_rid || '',
                sales_basis: this.data.sales_basis || 2,
                type: this.data.type || 2,
                sales_basis_lock: this.data && this.data.sales_basis_lock && this.data.sales_basis_lock == 2 ? false : true,
                type_lock: this.data && this.data.type_lock && this.data.type_lock == 2 ? false : true,
                config01_lock: this.data && this.data.config01_lock && this.data.config01_lock == 2 ? false : true,
                promotion_type_lock: this.data && this.data.promotion_type_lock && this.data.promotion_type_lock == 2 ? false : true,
                performance_unit_code: this.data.performance_unit_code || '',
                operation_type_code: this.data.operation_type_code || 2,
                business_unit_code: this.data.business_unit_code || '',
                performance_unit_lock: this.data && this.data.performance_unit_lock && this.data.performance_unit_lock == 2 ? false : true,
                business_unit_lock: this.data && this.data.business_unit_lock && this.data.business_unit_lock == 2 ? false : true
            };
        },
        //筛选列
        selectedColData() {
            let temp = JSON.parse(localStorage.getItem('detailList')).commodity_flow;

            processColDataToEdit(
                temp,
                this,
                {
                    white: [
                        'promotion_type',
                        'date',
                        'product_batch_number',
                        'quantity',
                        'total_price_tax_excluded',
                        'total_price_tax_included'
                    ]
                },
                {
                    business: 'business_rid',
                    partner: 'partner_rid',
                    representative: 'representative_rid',
                    demander: 'demander_rid',
                    supplier: 'supplier_rid',
                    sup_supplier: 'sup_supplier_rid',
                    product: 'product_rid',
                    sales_basis_label: 'sales_basis',
                    type_label: 'type',
                    sales_basis_lock_label: 'sales_basis_lock',
                    type_lock_label: 'type_lock',
                    config01_lock_label: 'config01_lock',
                    promotion_type_lock_label: 'promotion_type_lock',
                    performance_unit_lock_label: 'performance_unit_lock',
                    business_unit_lock_label: 'business_unit_lock',
                    performance_unit_name: 'performance_unit_code',
                    operation_type_code_label: 'operation_type_code',
                    business_unit_name: 'business_unit_code'
                }
            );
        },
        //取消
        cancel() {
            if (window.history.length <= 1) {
                this.$router.push({ path: '/flowSourceLists' });
            } else {
                this.$router.go(-1);
            }
        },
        //获取详情
        getData() {
            this.$api
                .commodityFlowDetail(this.queryParams)
                .then((res) => {
                    this.data = res.data;
                    this.initFormData();
                })
                .catch((error) => {});
        },
        //提交新增/编辑修改
        submit(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.doSubmit();
                    return true;
                } else {
                    return false;
                }
            });
        },
        doSubmit() {
            this.btnLoading = true;
            let uri = '';
            if (this.type == 'update') {
                uri = 'commodityFlowUpdate';
            } else {
                uri = 'commodityFlowInsert';
            }
            this.$api[uri](this.formData)
                .then((res) => {
                    this.btnLoading = false;
                    if (res.code == 0) {
                        this.$message({
                            message: '保存成功！',
                            type: 'success'
                        });
                    }
                    this.cancel();
                })
                .catch((error) => {
                    this.btnLoading = false;
                });
        }
    }
};
</script>
<style lang="scss" scoped="scoped">
</style>